module.exports = __webpack_public_path__ + "img/wechatpay.6469cba7.png";